<header class="dialog__header">
  <button class="dialog__close-icon" (click)="dismissAndConfirmChanges()">
    <svg-icon
      key="times"
      [fontSize]="'1em'"
    ></svg-icon>
  </button>
  <svg-icon
    key="address-card"
    class="dialog__icon"
    [fontSize]="'2.8rem'"
  ></svg-icon>

  <h1>{{ translationKeys[this.subjectType].title | transloco }}</h1>

  <p>{{ translationKeys[this.subjectType].desc | transloco }}</p>
</header>

<bulb-async-dropdown
  *ngIf="this.subjectType === 'BULB_USER'; else groupSelectionTemplate"
  fieldId="favorites"
	fieldLabel="{{ 'sharePanel.search.forUser' | transloco }}"
  [initialGroupFetch]="fetchRecentlySharedWith"
	[secondGroupFetch]="fetchSearchPage"
	(selectedOptions)="addSubjectPermissions($event)"
  [excludeGroupFetchItems]="updatedInvites"
></bulb-async-dropdown>

<ng-template #groupSelectionTemplate>
  <div class="input-field">

    <label class="input-field__label" for="groupsMultiSelect">{{ 'sharePanel.shareWithGroups' | transloco }}</label>

    <p-multiselect
      #groupsMultiSelect
      id="groupsMultiSelect"
      class="input"
      dataKey="id"
      optionLabel="displayName"
      [resetFilterOnHide]="true"
      [group]="true"
      [options]="groupedOptions"
      [showToggleAll]="false"
      [(ngModel)]="selectedGroups"
      (ngModelChange)="addSubjectPermissions($event)"
      (onPanelShow)="onPanelShow()"
      (onPanelHide)="onPanelHide()"
      panelStyleClass="bulb-invite-panel"
    >
      <ng-template let-value pTemplate="selectedItems" >
        <!-- Placeholder to maintain input height before and after selecting an option -->
        <div style="opacity: 0" [transloco]="'sharePanel.shareWithGroups'"></div>
      </ng-template>

      <ng-template let-group pTemplate="item">
          <bulb-unit-chip [unit]="group"></bulb-unit-chip>
      </ng-template>

    </p-multiselect>
  </div>
</ng-template>

<section class="input-field" *ngIf="invitesForChecklist.length > 0 || previouslyInvited.length > 0">
  <label class="input-field__label">{{ translationKeys[this.subjectType].label | transloco }}</label>
  <bulb-users-checklist
    [users]="invitesForChecklist"
    (onChange)="updateInvited($event)"
  ></bulb-users-checklist>
</section>

<footer class="dialog__footer">
  <aero-button
    (click)="dismissAndConfirmChanges()"
    labelCode="{{ 'sharePanel.cancel' | transloco }}"
    [aeroStyle]="cancelButtonStyle"
  >
  </aero-button>

  <aero-button
    (click)="acceptChanges()"
    labelCode="{{ 'sharePanel.save' | transloco }}"
  >
  </aero-button>
</footer>
